"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const react_select_async_paginate_1 = require("react-select-async-paginate");
const options_component_1 = __importDefault(require("./options-component"));
const menu_list_component_1 = __importDefault(require("./menu-list-component"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const MenuStage = (props) => {
    var _a;
    const { classes, handleChange, isInvalid = false, labelName, dataStructure, variant, ...restProps } = props;
    const mergedClasses = variant !== 'v3'
        ? {
            root: (0, clsx_1.default)(styles_modules_less_1.default.notifyOptionsRoot, classes === null || classes === void 0 ? void 0 : classes.root),
            selectContainer: (0, clsx_1.default)(styles_modules_less_1.default.notifyOptionsContainer, styles_modules_less_1.default['notify-root__NotifyCtn'], isInvalid && styles_modules_less_1.default['notifyOptionsContainer--valid']),
            select: (0, clsx_1.default)(styles_modules_less_1.default.notifyOptionsSelect, classes === null || classes === void 0 ? void 0 : classes.select),
            placeholder: styles_modules_less_1.default.notifyPlaceHolder,
            menu: {
                menuCtn: (0, clsx_1.default)(styles_modules_less_1.default.notifyMenuCtn, (_a = classes === null || classes === void 0 ? void 0 : classes.menu) === null || _a === void 0 ? void 0 : _a.menuCtn),
            },
        }
        : undefined;
    const handleChangeOption = (newValue) => {
        if ((0, isFunction_1.default)(handleChange)) {
            handleChange(newValue);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(pulse_components_1.PulseSelectBase, { classes: mergedClasses, dataStructure: dataStructure || null, TippyProps: {
                offset: [0, 10],
                placement: 'bottom-end',
                popperOptions: {
                    strategy: 'fixed',
                },
            }, menuShouldScrollIntoView: true, isMulti: false, isSearchable: false, components: {
                MenuList: (0, react_select_async_paginate_1.wrapMenuList)((propsMenu) => (react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default.menu__root, classes === null || classes === void 0 ? void 0 : classes.menuListCustom) },
                    react_1.default.createElement("div", { id: "arrow", "data-popper-arrow": true }),
                    react_1.default.createElement(menu_list_component_1.default, { ...propsMenu, label: labelName })))),
                // eslint-disable-next-line react/display-name
                Option: (0, react_1.forwardRef)((propsOption, ref) => {
                    const { data, ...basePropsOption } = propsOption;
                    return (react_1.default.createElement(options_component_1.default, { ...basePropsOption, data: data, label: labelName, handleChangeOption: handleChangeOption }));
                }),
            }, isClearable: false, hideMenuOnValueChange: true, insideModal: true, variant: variant, ...restProps })));
};
exports.default = MenuStage;
